<div class="card mt-1">
  <div class="card-body">
    <h4>Validate Patient Care Ownership</h4>
    <div>
      <div class="row">
        <div class="col-6">
          @if (!patientInteractionIsVerified) {
            <h5>Closest Patient Interaction to Rx {{ capture.patientOwnershipDateName | titlecase }} ({{ capture.patientOwnershipDate | date: 'MM/dd/yyyy' }}):</h5>
          }
          @if (patientInteractionIsVerified) {
            <h5>Verifying Patient Interaction ({{ capture.patientOwnershipDate | date: 'MM/dd/yyyy' }}):</h5>
          }
          <table class="table table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>DATE</th>
                <th>TYPE</th>
                <th>PROVIDER</th>
                <th>ENC-LOCATION</th>
                <th>ENC-TYPE</th>
              </tr>
            </thead>
            <tbody>
              <td>{{ closestPatientInteractionEhrIdentifier }}</td>
              <td>{{ closestPatientInteractionDate | date: 'MM/dd/yyyy' }}</td>
              <td>{{ closestPatientInteractionType }}</td>
              <td>{{ closestPatientInteractionProviderName }}</td>
              <td>{{ closestPatientInteractionLocation }}</td>
              <td>{{ closestPatientInteractionEncounterType }}</td>
            </tbody>
          </table>
          <div class="row mb-2">
            @if (!patientInteractionIsVerified) {
              <div class="col">
                @if (closestPatientInteractionValid) {
                  <div>
                    <p class="alert alert-success" role="alert">
                      Patient Interaction is within {{ patientOwnershipTimeframeInMonths }} months of Rx {{ capture.patientOwnershipDateName | titlecase }}
                    </p>
                  </div>
                } @else {
                  @if (!capture.verifyingPatientInteractionMustBeBeforePatientCareOwnershipDate) {
                    <p class="alert alert-danger" role="alert">
                      There is no encounter within the client's approved {{ capture.patientOwnershipDateName }} window.
                    </p>
                  }
                  @if (capture.verifyingPatientInteractionMustBeBeforePatientCareOwnershipDate) {
                    <p class="alert alert-danger" role="alert">
                      There is no encounter prior to the patient care ownership date within the client’s approved window.
                    </p>
                  }
                }
              </div>
            }
            @if (patientInteractionIsVerified) {
              <div class="col">
                <div>
                  <p class="alert alert-success" role="alert">Verified Patient Interaction</p>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="col-6">
          <h5>Patient's Encounters</h5>
          @if (patient) {
          <app-encounter-list
            [fetchEncounters]="fetchPatientEncounters"
            [eligibleCount]="patient.eligibleEncountersCount"
            [ineligibleCount]="patient.ineligibleEncountersCount"
          >
            <ng-template appEncounterTable let-encounters>
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>ENC-ID</th>
                    <th>ENC-DATE</th>
                    <th>ENC-PROVIDER</th>
                    <th>ENC-LOCATION</th>
                    <th>ENC-TYPE</th>
                    <th>ENC-PATIENT</th>
                    <th>ENC-EHR INSTANCE</th>
                  </tr>
                </thead>
                <tbody>
                  @for (encounter of encounters; track encounter) {
                    <tr class="encounter">
                      <td>{{ encounter.ehrIdentifier }}</td>
                      <td>{{ encounter.encounterDate | date: 'MM/dd/yyyy' }}</td>
                      <td>{{ encounter.providerDisplayNameWithNpi }}</td>
                      <td>{{ encounter.location }}</td>
                      <td>{{ encounter.encounterType }}</td>
                      <td class="phi">{{ encounter.sourcePatientMrn }}</td>
                      <td>{{ encounter.ehrInstance }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </ng-template>
          </app-encounter-list>
          }
        </div>

      </div>
    </div>
  </div>
</div>
